import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { green, red } from "@mui/material/colors";
import type React from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  type: "waiting" | "failed" | "confirmed" | "withdraw";
  errorMessage?: string;
  amount?: string;
  onAction: () => void;
}

export const BridgeProcessModal: React.FC<Props> = ({
  open,
  onClose,
  type,
  errorMessage = "Unknown error occurred",
  amount,
  onAction,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 6,
          padding: 7,
          alignItems: "center",
          width: "100%",
          background: "#F9F9F9",
          gap: 10,
        },
      }}
    >
      <Stack width="100%">
        <Stack
          onClick={onClose}
          marginLeft="auto"
          direction="row"
          spacing={2}
          component="div"
        >
          <CloseIcon sx={{ width: 20, height: 20, cursor: "pointer" }} />
        </Stack>
        <Typography variant="h3" alignSelf="center">
          {type === "waiting" && "Waiting for bridge"}
          {type === "failed" && "Deposit failed"}
          {type === "confirmed" && "Deposit Confirmed"}
          {type === "withdraw" && "Withdraw"}
        </Typography>
      </Stack>
      <DialogContent sx={{ width: "100%", padding: 0 }}>
        {type === "waiting" && (
          <Stack alignItems="center" spacing={10}>
            <CircularProgress />
            <Typography
              variant="body1"
              color="text.secondary"
              alignItems="center"
              textAlign="center"
            >
              Please sign the deposit on your wallet and wait a few moments for
              your deposit to finalize.
            </Typography>
            <Button
              size="small"
              variant="outlined"
              onClick={onClose}
              sx={{ width: "100%" }}
            >
              Back
            </Button>
          </Stack>
        )}
        {type === "failed" && (
          <Stack
            textAlign="center"
            alignItems="center"
            spacing={10}
            width="100%"
          >
            <WarningAmberIcon sx={{ fontSize: 48, color: red[500] }} />
            {errorMessage ? (
              <Typography textAlign="center" color="error">
                {errorMessage}
              </Typography>
            ) : null}
            <Button
              size="small"
              variant="outlined"
              onClick={onClose}
              sx={{ width: "100%" }}
            >
              Back
            </Button>
          </Stack>
        )}
        {type === "confirmed" && (
          <Stack textAlign="center" alignItems="center" spacing={10}>
            <CheckCircleOutlineIcon sx={{ fontSize: 58, color: green[500] }} />
            <Typography variant="body1">
              Bridging successfully initiated!{" "}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              The process may take anywhere from 2 minutes to 25 hours depending
              on the combination of networks.
            </Typography>
            <Button
              size="small"
              variant="outlined"
              onClick={onClose}
              sx={{ width: "100%" }}
            >
              Got it
            </Button>
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
};
